import { withRouter, generatePath } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getCurrentlyStagedFlowByFlowId } from 'automation-ui-canvas/selectors/flowSelectors';
import { useSelector } from 'react-redux';
import { CANVAS_ROOT } from 'automation-ui-canvas/constants/AbsolutePaths';
import { getScreenForFlowType } from 'automation-ui-canvas/utils/getScreenForFlowType';
import { buildSearchStringWithCurrentSourceFields } from 'automation-ui-canvas/utils/routingUtils';
import ModeIndicator from 'automation-ui-canvas/containers/enrollment-history/utils/ModeIndicator.tsx';
import UIEditorToolbar from 'UIComponents/nav/UIEditorToolbar';
import WorkflowNameWithDescription from 'automation-ui-management/components/WorkflowNameWithDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GoToEditPanelHeader = ({
  history,
  location,
  match,
  flowType
}) => {
  const {
    flowId
  } = match.params;
  const screen = getScreenForFlowType(flowType);
  const currentlyStagedFlow = useSelector(getCurrentlyStagedFlowByFlowId(Number(flowId)));
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIEditorToolbar, {
      titleText: /*#__PURE__*/_jsx(WorkflowNameWithDescription, {
        use: "on-dark",
        flow: currentlyStagedFlow ? currentlyStagedFlow.toHybridFlowInterface() : undefined,
        flowId: Number(flowId),
        readOnly: true
      })
    }), /*#__PURE__*/_jsx(ModeIndicator, {
      use: "preview",
      onCancel: () => {
        const pathname = generatePath(CANVAS_ROOT, {
          flowId,
          screen
        });
        const search = buildSearchStringWithCurrentSourceFields({
          location
        });
        history.replace({
          pathname,
          search
        });
      },
      modeTitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.goToEditCanvas.header"
      })
    })]
  });
};
export default withRouter(GoToEditPanelHeader);